
<script lang="ts" setup>
import DarwinButton from '@/uiKit/Button/DarwinButton.vue'
import Icon from '@/uiKit/Icon/Icon.vue'
import IconButton from '@/uiKit/Button/IconButton.vue'

import UpgradeDialogGeneric from './UpgradeDialogGeneric.vue'

defineProps<{ url?: string }>()
const emit = defineEmits<{ (e: 'close'): void }>()
</script>

<template>
  <div class="upgrade-dialog">
    <div class="upgrade-dialog-header">
      <div class="upgrade-dialog-header__icons">
        <Icon name="duotone-coin" />
        <IconButton
          flair="circle"
          kind="transparent"
          size="xs"
          @click="emit('close')"
        >
          <Icon name="mono-close" />
        </IconButton>
      </div>
      <div class="upgrade-dialog-header__title">
        <slot name="title">Upgrade your plan to unlock this feature</slot>
      </div>
      <div class="upgrade-dialog-header__subtitle">
        <slot name="subtitle"
          >This feature is restricted on your plan. Upgrade to access additional features</slot
        >
      </div>
    </div>
    <slot>
      <UpgradeDialogGeneric />
    </slot>

    <div class="upgrade-dialog-footer">
      <DarwinButton
        kind="outline"
        flair="rounded"
        size="md"
        to="?settings=plans"
        @click="emit('close')"
        >Explore plans</DarwinButton
      >
      <DarwinButton
        v-if="url"
        kind="primary"
        flair="rounded"
        size="md"
        :to="url"
        target="_blank"
        >Talk to sales</DarwinButton
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.upgrade-dialog {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.upgrade-dialog-header {
  padding: var(--size-4);
  display: flex;
  flex-direction: column;

  &__icons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    margin-bottom: var(--size-4);
  }

  &__title {
    @include textXL18pxBold;
  }

  &__subtitle {
    max-width: 408px;
    @include typographyRegularBody200;
    color: var(--color-text-subtle);
  }
}

.upgrade-dialog-footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  gap: var(--size-4);
  border-top: 1px solid var(--color-border-subtle);
  padding: var(--size-3) var(--size-4);
}
</style>
